import { getPortalName } from "@capone/common";

export const PRINT = "Print";
export const TITLE = "Itemized car receipt";
export const DRIVER_NAME = "Driver name";
export const CONFIRMATION_NUMBER = "Confirmation #";
export const INVOICE_DATE = "Invoice date";
export const PICK_UP = "Pick-up";
export const DROP_OFF = "Drop-off";
export const RENTAL_CAR = "Rental car";
export const VEHICLE = "Vehicle";
export const BASE_FARE = "Base fare";
export const TAXES_AND_FEES = "Taxes and fees";
export const DUE_AT_PICKUP = "Due at pick-up";
export const TOTAL_COST = "Total cost";
export const MMDDYYYY_FORMAT = "MM/DD/YYYY";
export const PAYMENT_INFO = "Payment info";
export const DEFAULT_DOC_ID = "car-itemized-receipt";
export const COPY1 = `*This total reflects your purchase through ${getPortalName()}. The rental company may provide a separate receipt for any charges arranged directly with them.`;
export const TRAVEL_CREDIT_APPLIED = "Capital One Travel Credit Applied";
export const TRAVEL_OFFER_APPLIED = "Capital One Travel Offer Applied";
export const TRAVEL_CREDITS_LINE_ITEM_APPLIED = "Travel credits applied";
export const TRAVEL_OFFER_LINE_ITEM_APPLIED = "Travel offer applied";
